import type { UseHttp } from '~/api/interface'

export const fetchExhibitionList: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/list', params, { ...option })
}

export const fetchExhibitionPage: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/page', params, { ...option })
}

export const fetchExhibitionFollow: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition-follow/follow', params, { ...option })
}

export const fetchExhibitionById: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/${params?.id}`, undefined, { ...option })
}

export const fetchExhibitionGroup: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibitionGroupApi/group', params, { ...option })
}

export const fetchExhibitionBoothInfoById: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/boothInfo/${params?.id}`, undefined, { ...option })
}

export const fetchExhibitionScoreById: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibitionScoreApi/getByEhibitionId', params, { ...option })
}

export const fetchVideoPlayAuth: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/getPlayAuth/${params?.vid}`, undefined, { ...option })
}

export const fetchApplyBooth: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibition/applyBooth`, params, { ...option })
}

export const fetchExhibitionDimension: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibition/dimension`, params, {
    ...option
  })
}

export const clientFetchExhibitionDimension: UseHttp = (params, option) => {
  return useHttp.post(`/api/exhibition/dimension`, params, {
    ...option
  })
}

export const fetchCityByType: UseHttp = (params, option) => {
  return useHttp.get(`/api/exhibition/city/${params?.type}`, undefined, { ...option })
}

export const clientFetchQueryListByKeyWord: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/queryListByKeyWord', params, { ...option })
}

export const clientFetchExhibitionSearch: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/search', params, { ...option })
}

export const fetchClientExhibitionSearch: UseHttp = (params, option) => {
  return useHttp.post('/api/exhibition/search', params, { ...option })
}
